import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import Tooltip from "@mui/material/Tooltip";
import SportrecsLogoIcon from "core/components/SportrecsLogoIcon";

const LogoButtonBase = styled(ButtonBase)(({ theme }) => ({
  padding: 6,
  color: "rgb(255, 255, 255)",
  borderRadius: 4,

  "@media (max-width: 450px)": {
    padding: 4,
  },

  [theme.breakpoints.up("sm")]: {
    padding: 10,
  },

  [theme.breakpoints.up("md")]: {
    padding: 12,
  },

  // Убираем все hover эффекты
  "&:hover": {
    backgroundColor: "transparent",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "transparent",
  },
}));

const ArenaLogo = styled("img")({
  height: 24,
  width: "auto",
  maxWidth: 120,
  objectFit: "contain",
});

/**
 * Полный горизонтальный логотип арены для превью эмбеда: в макете
 * «ВидеоСпортс — UI» это надпись высотой 20px при ширине плеера 744px,
 * в маленьком iframe уменьшается пропорционально.
 */
const ArenaLogoFull = styled("img")({
  height: "clamp(14px, 2.7vw, 20px)",
  width: "auto",
  maxWidth: "40vw",
  objectFit: "contain",
});

function LogoButton({ url, arena, variant = "embed" }) {
  const { t } = useTranslation("core");

  // В плеере маленький embedLogo, если задан, иначе обычный logo.
  // В превью эмбеда (variant="full") наоборот: полный логотип арены.
  const full = variant === "full";
  const logoUrl = full
    ? arena?.logo?.url || arena?.embedLogo?.url
    : arena?.embedLogo?.url || arena?.logo?.url;
  const Logo = full && arena?.logo?.url ? ArenaLogoFull : ArenaLogo;

  const logoElement = logoUrl ? (
    <Logo src={logoUrl} alt="Arena logo" />
  ) : (
    <SportrecsLogoIcon />
  );

  // Формируем текст для tooltip
  const tooltipText = arena?.title
    ? `Перейти на ${arena.title}`
    : t("logoButton");

  return (
    <Tooltip title={tooltipText} placement="top-end" arrow>
      <LogoButtonBase component="a" href={url} target="_blank" rel="noopener">
        {logoElement}
      </LogoButtonBase>
    </Tooltip>
  );
}

LogoButton.propTypes = {
  url: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["embed", "full"]),
  arena: PropTypes.shape({
    title: PropTypes.string,
    logo: PropTypes.shape({
      url: PropTypes.string,
    }),
    embedLogo: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
};

export default LogoButton;
